const { default: axios } = require("axios");
const { mapState } = require("vuex");

const app = async () => {
  const { Vue: Vue } = await import(/* webpackChunkName: "vue" */ "../global");
  const { default: Vuex } = await import(/* webpackChunkName: "vue" */ "vuex");
  const { default: PortalVue } = await import(/* webpackChunkName: "portal" */ "portal-vue");
  const { default: SlideOverMenu } = await import(/* webpackChunkName: "slide-over-menu" */ "../vue/SlideOverMenu");
  const { default: ToggleInput } = await import(/* webpackChunkName: "toggle-input" */ "../vue/ToggleInput");
  const { default: MobileMenu } = await import(/* webpackChunkName: "mobile-menu" */ "../vue/MobileMenu");
  const { default: vSelect } = await import(/* webpackChunkName: "vue-select" */ "vue-select");

  const { default: store } = await import(/* webpackChunkName: "store" */ "../store/store");
  Vue.use(PortalVue);

  Vue.component("slide-over-menu", SlideOverMenu);
  Vue.component("toggle-input", ToggleInput);
  Vue.component("mobile-menu", MobileMenu);
  Vue.component("vue-select", vSelect);

  const app = new Vue({
    name: "Header",
    el: "#site-header",
    store,
    data: () => ({
      accountMenuIsOpen: false,
      stockistMapOpen: false,
        companyCodeOpen: false,
        rangeNavigationOpen: false,
        styleNavigationOpen: false,
        announcementOpen: false,
      activeCompany: null,
      // wishlistCount: null,
    }),
      mounted() {
          this.announcementOpen = window.showAnnouncement;
      if (this.companyCodes && this.companyCodes.length) {
        this.activeCompany = this.companyCodes.find((company) => company.active);
      } else if (window.user) {
        this.activeCompany = window.user.companyID;
      }
      // this.fetchWishlist();
    },
    methods: {
      toggleAccountMenu() {
        this.accountMenuIsOpen = !this.accountMenuIsOpen;
      },
      // async fetchWishlist() {
      //   const { data } = await axios.get("/wishlist/getWishCount");
      //   this.wishlistCount = data;
      // },
      changeAdminView() {
        window.location.href = "/account/AdminViewChange";
      },
    },
    watch: {
      companyCodeOpen() {
        if (this.companyCodeOpen) {
          setTimeout(() => {
            this.$refs.companyCodeSelect.$refs.search.focus();
          }, 500);
        }
      },
    },

    computed: {
      companyCodes() {
        if (window.companyCodes) {
          return window.companyCodes.map((company) => ({
            ID: company.companyID,
            code: company.customerCode,
            label: `${company.customerCode} - ${company.companyName}`,
            active: company.companyID == window.user.companyID,
          }));
        }
      },
      ...mapState({
        user: (state) => state.user,
        wishlist: (state) => state.wishlist,
        adminView: (state) => state.adminView,
      }),
    },
    components: {
      "stockist-map": () => import(/* webpackChunkName: "stockists-map" */ "../vue/StockistMap"),
    },
  });
};

app().then((vm) => {});
